/* ============================================================
   MP DESCRIPTION TOGGLE — Troncatura + "Scopri di più"
   Target: .product__block.product__text .product__subheading
   (la descrizione "INFORMAZIONI" della pagina prodotto)
   ============================================================ */
(function () {
  'use strict';

  var THRESHOLD = 130; // se l'altezza reale è <= a questa, NON serve il toggle
  var SELECTOR = 'body.template-product .product__block.product__text';

  function initBlock(block) {
    if (block.dataset.mpDescInit === '1') return;
    var sub = block.querySelector('.product__subheading');
    if (!sub) return;

    // Misura altezza reale (scrollHeight ignora overflow: hidden)
    var fullHeight = sub.scrollHeight;
    if (fullHeight <= THRESHOLD) {
      // descrizione corta → rimuovi il limite e non aggiungere il bottone
      sub.style.maxHeight = 'none';
      sub.style.overflow = 'visible';
      block.dataset.mpDescInit = '1';
      return;
    }

    block.dataset.mpDescInit = '1';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mp-desc-btn';
    btn.innerHTML = 'Scopri di più <span class="mp-desc-btn__arr" aria-hidden="true">→</span>';
    btn.setAttribute('aria-expanded', 'false');

    btn.addEventListener('click', function () {
      var isOpen = sub.classList.toggle('mp-desc-open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) {
        btn.classList.add('mp-hidden');
      }
    });

    block.appendChild(btn);
  }

  function init() {
    var blocks = document.querySelectorAll(SELECTOR);
    blocks.forEach(initBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Re-inizializza dopo eventuali reload di section (theme editor)
  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 60);
  });
})();
